import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/siteData';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteInfo.url}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  email: siteInfo.contactInfo.email,
  telephone: siteInfo.contactInfo.phone,
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressCountry: 'CN',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '福利导航在线观看是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '福利导航在线观看是一个精选资源一站式导航平台，我们汇聚全网优质在线资源，按分类整理，为用户提供便捷的导航服务。',
      },
    },
    {
      '@type': 'Question',
      name: '使用福利导航需要付费吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '完全免费！福利导航在线观看始终坚持以免费服务为核心，所有资源导航服务均不收取任何费用。',
      },
    },
    {
      '@type': 'Question',
      name: '网站的资源多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们的内容团队每天都会对网站资源进行更新和维护，确保用户能够及时获取最新的热门资源。',
      },
    },
    {
      '@type': 'Question',
      name: '如何快速找到我想要的资源？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过首页的分类导航区域快速浏览不同类别的资源。我们也提供了搜索功能，只需输入关键词，即可快速定位到相关内容。',
      },
    },
    {
      '@type': 'Question',
      name: '网站支持手机访问吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '当然支持！福利导航在线观看采用响应式设计，完美适配手机、平板和电脑等各种设备。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系我们提供反馈或建议？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过关于我们页面的联系表单提交您的建议和意见，也可以发送邮件至官方邮箱。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}